import React from "react";
import PropTypes from "prop-types";
import { Input, Label } from "reactstrap";

const CHECK_TYPES = new Set(["checkbox", "radio", "switch"]);

export default function CustomInputCompat({
  type,
  id,
  label,
  inline,
  className,
  invalid,
  children,
  ...restProps
}) {
  if (type === "select") {
    return (
      <Input
        type="select"
        id={id}
        className={className}
        invalid={invalid}
        {...restProps}
      >
        {children}
      </Input>
    );
  }

  if (!CHECK_TYPES.has(type)) {
    return (
      <Input
        type={type}
        id={id}
        className={className}
        invalid={invalid}
        {...restProps}
      />
    );
  }

  const wrapperClassName = [
    "form-check",
    inline ? "form-check-inline" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <Input
        {...restProps}
        type={type}
        id={id}
        invalid={invalid}
        className={invalid ? "is-invalid" : ""}
      />
      {label ? (
        <Label className="form-check-label" htmlFor={id}>
          {label}
        </Label>
      ) : null}
    </div>
  );
}

CustomInputCompat.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inline: PropTypes.bool,
  className: PropTypes.string,
  invalid: PropTypes.bool,
  children: PropTypes.node,
};

CustomInputCompat.defaultProps = {
  type: "text",
  id: undefined,
  label: null,
  inline: false,
  className: "",
  invalid: false,
  children: null,
};
